import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SeoWidgetItem } from '../../../business/seo/seo-widget-item';

@Component({
    selector: 'ecm-mat-seo-widgets',
    templateUrl: 'material-seo-widgets.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass],
})
export class MaterialSeoWidgetsComponent {
    @Input() public title?: string;
    @Input() public subTitle?: string;
    @Input({ required: true }) public items: SeoWidgetItem[];
    @Input() public e2e = 'e2e-mat-seo-widgets';
    @Output() public clickWidgetButton = new EventEmitter<number>();
}
